'use client';

import clsx from 'clsx';
import { CSSProperties, FC, useState } from 'react';
import { Slide } from 'atoms/Carousel';
import { DynamicCarousel } from 'atoms/Carousel/DynamicCarousel';
import { NavigationTypes } from 'molecules/Slider/NavigationButtons';
import { HomePageTile } from 'organisms/ProductTile/HomePageTile';
import { useMediaQuery } from 'modules/mui/hooks';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';
import styles from './PinnedSlider.module.css';

export const DESKTOP_MAX_PER_VIEW = 4;
export const DESKTOP_SLIDE_FRACTION = 0.5;

export const PinnedSlider: FC<{ products?: IAdaptedListProduct[] }> = ({
  products = [],
}) => {
  const { isMobile, isDesktop } = useMediaQuery();
  const [isInitialized, setIsInitialized] = useState(false);

  const desktopSlidesPerView =
    products.length > DESKTOP_MAX_PER_VIEW
      ? DESKTOP_MAX_PER_VIEW + DESKTOP_SLIDE_FRACTION
      : DESKTOP_MAX_PER_VIEW;

  return (
    <div
      className={styles.grid}
      style={
        {
          '--desktop-slides-per-view': desktopSlidesPerView,
        } as CSSProperties
      }
    >
      <DynamicCarousel
        buttonNextClass={styles.next}
        buttonPrevClass={styles.prev}
        buttonContainerClass={styles.navigation}
        navigationType={NavigationTypes.COMPACT}
        pagination={{
          enabled: !(isDesktop && products.length <= DESKTOP_MAX_PER_VIEW),
          el: `.${styles.pagination}`,
          horizontalClass: styles.pagination,
        }}
        navigation={{
          enabled:
            !isMobile &&
            !(isDesktop && products.length <= DESKTOP_MAX_PER_VIEW),
          disabledClass: styles.navDisabled,
          hiddenClass: styles.hidden,
          lockClass: styles.hidden,
        }}
        spaceBetween={16}
        slidesPerView={isDesktop ? desktopSlidesPerView : 'auto'}
        className={styles.carousel}
        wrapperClass={styles.wrapper}
        onInit={() => {
          setIsInitialized(true);
        }}
      >
        {products.map((product) => (
          <Slide
            //* Reset width to css value after slidesPerView changes to auto  */
            style={!isDesktop ? { width: '' } : {}}
            key={product.id}
            className={clsx(
              styles.slide,
              !isInitialized && styles.slideFallback,
            )}
          >
            <HomePageTile product={product} />
          </Slide>
        ))}
      </DynamicCarousel>
      <div className={styles.pagination} />
    </div>
  );
};
